import axios from 'axios';
import { Logger } from '../Logger';
import { RetailerPersonalData } from '../../common-types/GlobalRetailerPersonalDataState.type';


class PersonalDataService {
  private readonly host: string;

  private readonly disabled: boolean;

  public constructor () {
    this.host = process.env.REACT_APP_PERSONAL_DATA_BASE_URL as string;
    this.disabled = typeof this.host !== 'string' || this.host.trim().length === 0;
  }

  public async getCustomerPersonalData (siteKey: string, customerUid: string): Promise<RetailerPersonalData> {
    const url = `${this.host}/v1/site/${siteKey}/customer/${customerUid}/data`;
    const personalData: RetailerPersonalData = {
      optinList: null,
      email: null,
    };
    // Avoid fucked up call 'til we defined and mount a host for proper backend
    if (this.disabled) {
      return personalData;
    }
    try {
      // Set a timeout of 2 seconds to avoid waiting too long when this go in production without the backend
      // I bet it will happen...
      const { data } = await axios.get(url, { timeout: 2000 });
      if (Array.isArray(data?.optinList)) {
        personalData.optinList = data.optinList;
      }
      if (typeof data?.email === 'string' && data.email.trim().length > 0) {
        personalData.email = data.email.trim();
      }
    } catch (error) {
      Logger.error('could not get CustomerPersonalData', error);
    }
    return personalData;
  }

  public async saveOptins (siteKey: string, customerUid: string, consents: Record<string, boolean>): Promise<void> {
    // Avoid fucked up call 'til we defined and mount a host for proper backend
    if (this.disabled) {
      return;
    }
    const url = `${this.host}/v1/site/${siteKey}/customer/${customerUid}/optins`;
    const data = {
      optinList: Object.entries(consents).map(([key, value]) => ({ key, value })),
    };
    if (data.optinList.length === 0) {
      return;
    }
    try {
      // Set a timeout of 2 seconds to avoid waiting too long when this go in production without the backend
      // I bet it will happen...
      await axios.post(url, data, { timeout: 2000 });
    } catch (error) {
      Logger.error('could not get save consents', error);
    }
  }
}

export const personalDataServiceInstance = new PersonalDataService();
